import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import reduce from 'ramda/src/reduce'

const styles = {
	rectangles: {
		display: 'flex',
	},
	rectangle: {
		height: 2,
		width: '100%',
		margin: [[5, 2]],
	},
}

const InputStrengthComponent = ({ classes, length, strengthDescription }) => (
	<div className={classes.rectangles}>
		{Array.from({ length: 10 }).map((e, i) => (
			<div
				className={classes.rectangle}
				/* eslint-disable-next-line react/no-array-index-key */
				key={i}
				style={{ opacity: length - 1 >= i ? 1 : 0.3,
					backgroundColor:
				// eslint-disable-next-line max-len
				reduce((acc, item) => ((item.value <= length) ? item.color : acc), 'red', strengthDescription) }}
			/>
		)) }
	</div>
)

export default withStyles(styles, { name: 'MuiInputStrengthComponent' })(InputStrengthComponent)
